import { API_URL } from '../config';

export async function api<T>(path: string, token?: string | null, body?: unknown, method?: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(`${API_URL.replace(/\/$/, '')}${path}`, {
    method: method ?? (body === undefined ? 'GET' : 'POST'), signal,
    headers: { ...(token ? { authorization: `Bearer ${token}` } : {}), ...(body === undefined ? {} : { 'content-type': 'application/json' }) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(data.error ?? `API ${response.status}`);
  return data;
}

export interface TokenSummary {
  curve_address: string; minter_address: string | null; deployer: string;
  name: string | null; ticker: string | null; imageUrl: string | null;
  phase: string; real_ton: string; dev_buy_ton: string; seed_ton: string; created_at: number;
}

export interface Passport {
  deployer: string; holders: number; seedTon: string; devBuyTon: string;
  deployerHistory: { launches: number; graduations: number };
  telegramChannel: { chatId: number; title: string | null; username: string | null; subscribers: number | null;
    ownerVerified: boolean; firstSeenAt: number | null } | null;
}

export interface IndexedToken extends TokenSummary {
  passport: Passport; cardPublished: boolean;
  feeEarnings?: { total: string; deposits: number };
}
